import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "../constants/contact";

const callConversionSendTo =
  process.env.REACT_APP_GOOGLE_ADS_CALL_CONVERSION_SEND_TO ||
  "AW-18154755174/YmqXCPW1h7AcEOao7tBD";
const leadConversionSendTo =
  process.env.REACT_APP_GOOGLE_ADS_LEAD_CONVERSION_SEND_TO;

const hasWindow = () => typeof window !== "undefined";

const pushDataLayerEvent = (eventName, params = {}) => {
  if (!hasWindow()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

const fireGoogleAdsConversion = (sendTo, params = {}) => {
  if (!hasWindow() || !sendTo || typeof window.gtag !== "function") {
    return false;
  }

  window.gtag("event", "conversion", {
    send_to: sendTo,
    ...params,
  });

  return true;
};

export const trackLeadSubmission = ({ source = "website", type = "lead" } = {}) => {
  const eventParams = {
    event_category: "lead",
    event_label: source,
    lead_type: type,
    lead_source: source,
  };

  pushDataLayerEvent("lead_form_submit", eventParams);
  pushDataLayerEvent("generate_lead", eventParams);
  fireGoogleAdsConversion(leadConversionSendTo, eventParams);
};

export const trackPhoneCallClick = ({
  source = "website",
  callback,
} = {}) => {
  let callbackWasCalled = false;
  const safeCallback = () => {
    if (callbackWasCalled) {
      return;
    }

    callbackWasCalled = true;
    callback?.();
  };

  const eventParams = {
    event_category: "phone_call",
    event_label: source,
    phone_number: SUPPORT_PHONE_DISPLAY,
    phone_number_tel: SUPPORT_PHONE_TEL,
    link_url: `tel:${SUPPORT_PHONE_TEL}`,
    call_source: source,
  };

  pushDataLayerEvent("phone_call_click", eventParams);

  const firedGoogleAdsConversion = fireGoogleAdsConversion(callConversionSendTo, {
    ...eventParams,
    event_callback: safeCallback,
    event_timeout: 1000,
  });

  if (firedGoogleAdsConversion) {
    window.setTimeout(safeCallback, 1100);
  } else {
    safeCallback();
  }
};
